import axios from 'axios';

const RESOURCE_NAME = '/api/contact';

export default {
    getAll() {
        return axios.get(RESOURCE_NAME);
    },

    getPaged(_pageSize, _pageNumber, _sortProp, _sortDir) {
        return axios.get(`${RESOURCE_NAME}?pageSize=${_pageSize}&pageNumber=${_pageNumber}&sortProp=${_sortProp}&sortDir=${_sortDir}`);
	},
	
    search(query) {
        return axios.get(`${RESOURCE_NAME}?q=${query}`);
	},
	
	getContacts(id){
        return axios.get(`/api/clock/${id}/contact`);
	},
    
    get(id) {
        return axios.get(`${RESOURCE_NAME}/${id}`);
    },

    create(data) {
        return axios.post(RESOURCE_NAME, data);
    },

    update(id, data) {
        return axios.put(`${RESOURCE_NAME}/${id}`, data);
    },

    delete(id) {
        return axios.delete(`${RESOURCE_NAME}/${id}`);
    }
};


// WEBPACK FOOTER //
// ./src/api-services/contact.service.js